var $j = jQuery.noConflict();

$j(document).ready(function(){

	//remove hover dropdown from main menu for mobile
	// var windowWidth = $j(window).width();
	// if(windowWidth < 768){
	//     $( '#menu-main-menu a.dropdown-toggle' ).doubleTapToGo();
	// }

  /**
   *    add btn class to gravity forms button
   */
  $j('.gform_footer').find('.gform_button').addClass('btn btn-primary');

  /**
   *    Tab navigation and scrollto
   *    @type {[type]}
   */
  var $tabs = $j('.nav-tabs li');

  // This is a functions that scrolls to #id
  function scrollTo(id){
    // Scroll
     $j('html,body').animate({scrollTop: $j("#"+id).offset().top - 200},'slow');
  }

  $j('#prevtab').on('click', function() {
      $tabs.filter('.active').prev('li').find('a[data-toggle="tab"]').tab('show');
      scrollTo("tabtop");

  });

  $j('#nexttab').on('click', function() {
      $tabs.filter('.active').next('li').find('a[data-toggle="tab"]').tab('show');
      scrollTo("tabtop");
  });

  /**
   *    Mean Menu
   */
  $j('.mobile-main-nav').meanmenu({
    meanShowChildren: true,
    meanMenuContainer: '.meanholder',
    meanScreenWidth: "992",
    meanMenuClose: '<span></span><span></span><span></span>',
  }
  );

});